module.exports = __webpack_public_path__ + "static/agenciesMarketingEmployeeHandbook-9a5bd98915046b1672fdea09f0fa2dbd.png";